import { Wrapper, Article, Header, Content, Footer } from './styles'

export default function TermsAndConditions() {
  return (
    <Wrapper>
      <Article>
        <Header>
          <img src="/logo.svg" alt="MeniuDigital" className="logo" />
          <h1>Termeni și condiții</h1>
          <div className="subtitle">Actualizat: 13 Noiembrie 2024</div>
        </Header>

        <Content>
          <div className="highlight">
            <strong>Vă rugăm să citiți cu atenție aceste condiții înainte de a accesa sau utiliza serviciile.</strong>
          </div>

          <p>
            Prezentele condiții de utilizare („Condițiile") reglementează accesarea și utilizarea de către dumneavoastră, persoană
            fizică sau juridică, a website-ului, produselor și serviciilor (denumite în mod colectiv „Serviciile") puse la
            dispoziție de MeniuDigital („MeniuDigital"), o societate cu răspundere limitată, TOUCHFREEMENU S.R.L., înființată în
            România, cu sediul în Sighetu Marmației, strada Șugău, nr. 46A, Județul Maramureș, înregistrată la Registrul
            Comerțului cu numărul J24/1306/05.08.2021, Cod Unic de Înregistrare 44695880, email: contact@meniudigital.ro.
          </p>

          <p>
            Condițiile prezentate în această pagină sunt valabile pentru website-ul www.meniudigital.ro și pentru orice alt
            website conex către care vei fi redirecționat în vederarea utilizării serviciului oferit de platforma MeniuDigital, cu
            excepția cazului în care sunt specificate în mod expres alte condiții de utilizare pe website-ul către care s-a făcut
            redirecționarea.
          </p>

          <p>
            Accesarea și utilizarea de către dumneavoastră a Serviciilor constituie acordul dumneavoastră de a respecta aceste
            Condiții, fapt ce dă naștere unei relații contractuale între dumneavoastră și MeniuDigital. Dacă nu sunteți de acord
            cu aceste Condiții, nu puteți accesa sau utiliza Serviciile. Prin acordul dumneavoastră de a respecta aceste Condiții,
            declarați și garantați că aveți cel puțin vârsta de 18 ani și capacitatea necesară pentru a încheia un astfel de
            acord.
          </p>

          <h2>Servicii</h2>
          <p>
            MeniuDigital oferă servicii de digitalizare a meniului culinar oferit de restaurantul/hotelul/cafeneaua/barul
            dumneavoastră, prin intermediul website-ului <a href="https://admin.meniudigital.ro">https://admin.meniudigital.ro</a>
            . De asemenea, prin intermediul website-ului <a href="https://www.meniudigital.ro">https://www.meniudigital.ro</a>{' '}
            (denumite împreună „Platforma MeniuDigital"), MeniuDigital permite afișarea variantei digitale a meniului dumneavostră
            către potențialii clienți.
          </p>

          <p>
            Descrierea detaliată a serviciilor de digitalizare și accesare se regăsește pe website-ul de prezentare al Platformei
            MeniuDigital (<a href="https://www.meniudigital.ro">https://www.meniudigital.ro</a>).
          </p>

          <h2>Utilizarea Serviciilor</h2>

          <h3>Începerea/prelungirea colaborării</h3>
          <p>
            Pentru a beneficia de serviciile de digitalizare trebuie să vă creați un cont pe Platformă. Orice informație cu
            caracter personal furnizată în continuare va fi supusă condițiilor din{' '}
            <a href="/privacy-policy">Politica de confidențialitate</a>.
          </p>

          <h3>Contul de utilizator</h3>
          <p>
            Pentru gestionarea meniului aveți acces la un cont personal activ de utilizator al Serviciilor, datele furnizate de
            dumneavoastră fiind astfel salvate, fără a mai fi necesară introducerea lor pentru următoarele comenzi. Vă asumați
            responsabilitatea pentru păstrarea confidențialității datelor de acces în Contul dumneavoastră. Sunteți singurul
            responsabil pentru toate activitățile desfășurate prin Contul dumneavoastră de utilizator cu excepția faptului că
            MeniuDigital poate, în anumite circumstanțe, să acceseze Contul pentru a efectua modificări pe care le solicitați.
          </p>

          <p>
            Dacă suspectați desfășurarea unei activități neautorizate prin Contul dumneavoastră sau orice altă încălcare a
            securității, trebuie să ne contactați imediat la contact@meniudigital.ro.
          </p>

          <h3>Comunicarea cu MeniuDigital</h3>
          <p>
            Prin începerea folosirii Platformei, sunteți de acord că MeniuDigital vă poate apela sau trimite email-uri pentru a
            facilita prestarea Serviciilor, în cadrul operațiunilor normale asociate cu utilizarea de către dumneavoastră a
            Serviciilor. Dumneavoastră puteți contacta MeniuDigital în legătură cu orice nemulțumire, sugestie sau orice alt
            aspect legat utilizarea Serviciilor la adresa de email sau la numărul de telefon care se regăsesc pe Platformă.
          </p>

          <p>
            Întregul conținut furnizat de către dumneavoastră ca utilizator va rămâne proprietatea dumneavoastră. Totuși, prin
            furnizarea de conținut către MeniuDigital dumneavoastră ca utilizator, acordați MeniuDigital dreptul de a utiliza, a
            copia, a modifica, a crea opere derivate, a distribui, a afișa public, a reprezenta public și a exploata în orice alt
            mod respectivul conținut furnizat de utilizator în toate formatele și pe toate canalele de distribuție, fără a vă
            informa și fără a fi necesar acordul dumneavoastră, și fără a fi nevoie să vă plătească fie pe dumneavoastră, fie o
            altă persoană fizică sau juridică.
          </p>

          <div className="highlight">
            Vă obligați să nu transmiteți un conținut cu caracter denigrator, calomnios, violent, obscen, pornografic, ilegal sau
            jignitor.
          </div>

          <h3>Accesul la rețea și dispozitivele</h3>
          <p>
            Vă revine responsabilitatea de a obține accesul la rețeaua de date necesar pentru a utiliza Serviciile. Se pot aplica
            tarifele și prețurile percepute de rețeaua dumneavoastră mobilă pentru transferul de date și mesaje, dacă accesați sau
            utilizați Serviciile de pe un dispozitiv care permite comunicarea wireless, și vă revine responsabilitatea de a achita
            aceste tarife și prețuri.
          </p>

          <h2>Plata</h2>
          <p>
            Utilizarea Serviciilor determină costuri pe care trebuie să le achitați. Prețurile sunt cele afișate pe Platformă, iar
            acestea pot fi modificate în orice moment, fără ca modificarea să aibă efect asupra comenzilor deja plasate. Prestarea
            serviciilor sunt condiționate de efectuarea plății.
          </p>

          <p>
            Plata se va efectua exclusiv online, prin redirecționarea către o platformă specializată{' '}
            <a href="https://netopia-payments.com/">Netopia MobilPay</a> folosind carduri de tip Visa sau MasterCard. MeniuDigital
            va depune diligențele necesare pentru a vă informa cu privire la prețurile aplicabile.
          </p>

          <h2>Politica de livrare</h2>
          <p>
            Datele de facturare folosite vor fi cele comunicate în momentul începerii colaborării. Dacă doriți modificarea datelor
            de facturare, vă rugăm să ne contactați prin una dintre metodele de contact disponibile.
          </p>

          <h2>Confidențialitate</h2>
          <p>
            Pentru a afla cum folosim datele tale cu caracter personal pe care le colectăm atunci când folosești platforma
            MeniuDigital, te rugăm să consulți <a href="/privacy-policy">Politica de confidențialitate</a>.
          </p>

          <h2>Siguranța datelor</h2>
          <p>
            Vom păstra anumite date pe care le transmiteți Platformei în scopul gestionării performanței site-ului, precum și date
            referitoare la utilizarea dvs. a Platformei. Deși efectuăm regulat copii de siguranță de rutină ale datelor, sunteți
            singurul responsabil pentru toate datele pe care le transmiteți sau care se referă la orice activitate pe care ați
            întreprins-o folosind Site-ul.
          </p>

          <h2>Dispoziții diverse</h2>

          <h3>Proprietatea</h3>
          <p>
            Serviciile și toate drepturile asociate cu acestea sunt și vor rămâne proprietatea MeniuDigital. Conținutul acestui
            site nu poate fi utilizat, reprodus, distribuit, transmis, expus, în alte scopuri decât cele expres și legal permise.
          </p>

          <h3>Restricții</h3>
          <p>Vă sunt interzise următoarele:</p>
          <ul>
            <li>
              Să îndepărtați marcajele privind drepturile de autor, mărcile comerciale sau alte drepturi de proprietate de pe vreo
              porțiune a Serviciilor
            </li>
            <li>
              Să reproduceți, să modificați, să realizați opere derivate, să distribuiți, să licențiați, să închiriați, să
              vindeți, să revindeți, să transferați, să afișați public, să reprezentați public, să transmiteți, să faceți
              streaming, să difuzați sau să exploatați în orice alt mod Serviciile
            </li>
            <li>Să decompilați, să refaceți prin inginerie inversă sau să dezasamblați Serviciile</li>
            <li>Să faceți frame-uri către vreo porțiune a Serviciilor</li>
            <li>
              Să determinați sau să lansați programe sau scripturi care fac scraping, indexează, analizează sau efectuează orice
              alte operațiuni de extragere de date din vreo porțiune a Serviciilor
            </li>
          </ul>

          <h3>Legislația aplicabilă și jurisdicția</h3>
          <p>
            Utilizarea serviciilor de către dumneavoastră este guvernată de legislația română. Orice litigii apărute între
            dumneavoastră și MeniuDigital vor fi soluționate pe cale amiabilă sau, în cazul în care acest lucru nu va fi posibil,
            litigiile vor fi soluționate de către instanțele judecătorești competente.
          </p>
        </Content>

        <Footer>
          <h3>Contact</h3>
          <div className="company-info">
            <strong>TOUCHFREEMENU SRL</strong>
            Strada Șugău nr. 46A
            <br />
            Sighetu Marmației, Maramureș 435500
            <br />
            România
            <br />
            <br />
            <strong>E-mail:</strong> <a href="mailto:contact@meniudigital.ro">contact@meniudigital.ro</a>
            <br />
            <br />
            C.U.I.: 44695880
            <br />
            Reg.Com.: J24/1306/05.08.2021
          </div>

          <div className="links">
            <a href="/delivery-terms">Politica de livrare</a>
            <a href="/cancellation-policy">Politica de anulare</a>
            <a href="/privacy-policy">Confidențialitate</a>
          </div>
        </Footer>
      </Article>
    </Wrapper>
  )
}
